/*
 * Copyright (c) 2024-2025. Bluemate B.V.
 */

import './style/bluematePlaceholderOverlay.scss';
import React from 'react';

import Image from './image';

import classNames from 'classnames';

interface Props {
    className?: string;
}

export default function BluematePlaceholderOverlay({className}: Props) {
    return (
        <div className={classNames('bluemate-placeholder-overlay', className)}>
            <Image
                name='logo-no-text-gray'
                alt='Bluemate'
                className='loading-logo'
                style={{maxHeight: '25%', minHeight: '4rem'}}
            />
        </div>
    );
}
